import type { HoverIdleSaveData } from "@/features/hoverIdle/persistence/hoverIdleSaveData";
import type {
  OfflineRewardBaseline,
  OfflineRewardReceipt,
} from "./offlineRewardReceipt";

export const OFFLINE_REWARD_FORMULA_VERSION = "tim-reward-v1" as const;

export interface OfflineRewardInput {
  readonly startSave: HoverIdleSaveData;
  readonly baseline: OfflineRewardBaseline;
  readonly revision: number;
  readonly inputDigest: string;
  readonly gameElapsedMs: number;
  readonly wasCapped: boolean;
  readonly rewardFormulaVersion: typeof OFFLINE_REWARD_FORMULA_VERSION;
}

export interface OfflineRewardResult {
  readonly finalSave: HoverIdleSaveData;
  readonly rewardId: string;
  readonly timDelta: string;
  readonly resultDigest: string;
  readonly receipt: OfflineRewardReceipt;
}

export interface OfflineRewardElapsed {
  readonly realElapsedMs: number;
  readonly uncappedGameElapsedMs: number;
  readonly rewardElapsedMs: number;
  readonly wasCapped: boolean;
}

export type OfflineRewardCommitFailureCode =
  | "invalid-result"
  | "stale-revision"
  | "stale-baseline"
  | "stale-input-digest"
  | "duplicate-reward";

export interface OfflineRewardCommitFailure {
  readonly code: OfflineRewardCommitFailureCode;
  readonly message: string;
}

export type OfflineRewardValidationResult =
  | { readonly ok: true }
  | {
      readonly ok: false;
      readonly errors: readonly {
        readonly code:
          | "invalid-input"
          | "invalid-save"
          | "digest-mismatch"
          | "receipt-mismatch"
          | "tim-reward"
          | "state-mismatch";
        readonly path: string;
        readonly message: string;
      }[];
    };
